import { Button, IconButton } from 'component/Button'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { UserButton } from 'page/catalog/BoutiqueHeader/UserButton'
import { ComboCartIndicator } from 'page/catalog/ComboCart'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { boutiqueQrModal, BoutiqueQrModalStore } from 'page/catalog/store/BoutiqueQrModalStore'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { user } from 'page/catalog/store/UserStore'
import { userModal, UserModalStore } from 'page/catalog/UserModal/store/UserModalStore'
import { useRef } from 'react'
import { ui } from 'store/home/ui/HomeUiStore'
import { formatDateTimeShort } from 'util/date'
import { space } from 'util/typo'
import css from './BoutiqueUserPane.module.scss'

export const BoutiqueUserPane = observer(() => {
  const { small } = ui.window
  const { data } = useDemo()
  const { widget_user_id, last_time } = user.optional ?? {}
  const client = !!employee.user && small
  const disabled = !widget_user_id

  const observer = useRef<ResizeObserver>()

  const onRef = useLatestCallback((element: HTMLDivElement | null) => {
    observer.current?.disconnect()
    observer.current = undefined
    if (!element) return

    function resize() {
      const height = element?.clientHeight
      document.body.style.setProperty('--boutique-bottom', height + 'px')
    }

    observer.current = new ResizeObserver(resize)
    observer.current.observe(element)
    resize()
  })

  const onSearch = useLatestCallback(() => {
    userModal.open(new UserModalStore(data))
  })

  const onFavorites = useLatestCallback(() => {
    user.it.fav()
  })

  const onQr = useLatestCallback(() => {
    if (widget_user_id)
      boutiqueQrModal.open(new BoutiqueQrModalStore(widget_user_id))
  })

  const onOpenComboCart = useLatestCallback(() => {
    comboCartStore.open = true
  })

  if (!client) return null

  if (!user.present) return (
    <Space ref={onRef} className={css.pane} pad={16}>
      <Button height={48} gap={8} large primary wide action={onSearch}>
        <Icon size={16} name="search" />
        {i18n('FindCustomer')}
      </Button>
    </Space>
  )

  return <Vertical ref={onRef} className={css.pane}>
    <Space pad={12} gap={12} opposite>
      <Space flex="1" oh>
        <UserButton />
      </Space>
      <Space>
        <IconButton large action={onFavorites} disabled={disabled}>
          <Icon size={16} name="favorite" />
        </IconButton>
        <IconButton large action={onQr} disabled={disabled}>
          <Icon size={16} name="qr_code" />
        </IconButton>
        <ComboCartIndicator onOpen={onOpenComboCart} />
      </Space>
    </Space>
    {last_time && <Divider secondary />}
    {last_time && <Space pad={[8, 12]} center>
      <Typo size={11} line={12} secondary>
        {i18n('LatestGeneration')}
        {space}
        {formatDateTimeShort(last_time)}
      </Typo>
    </Space>}
  </Vertical>
})
